import { render, staticRenderFns } from "./softwareImg.vue?vue&type=template&id=3f0fc086&scoped=true&"
import script from "./softwareImg.vue?vue&type=script&lang=js&"
export * from "./softwareImg.vue?vue&type=script&lang=js&"
import style0 from "./softwareImg.vue?vue&type=style&index=0&id=3f0fc086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0fc086",
  null
  
)

export default component.exports